module.exports = __webpack_public_path__ + "assets/people/arinaLyakh.639a8b9f4aec2887ea92becefbd0b0a1.png";